import React, { useState, useEffect } from "react";
import axios from "../api/axiosInstance";
import { useNavigate } from "react-router-dom";
import "../styles/globalCss.css";

function Users() {
  const [viewMode, setViewMode] = useState("create");
  const [users, setUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [togglingId, setTogglingId] = useState(null);
  const [isLoadingUsers, setIsLoadingUsers] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [newUser, setNewUser] = useState({
    userName: "",
    password: "",
    fullName: "",
    dailyBalanceInGold: 0,
    email: "",
  });

  const [error, setError] = useState("");

  // --- Edit user state ---
  const [editingUser, setEditingUser] = useState(null);
  const [editForm, setEditForm] = useState({
    fullName: "",
    age: "",
    gender: "Male",
    isActive: true,
    address: "",
    phone: "",
    nationalCode: "",
    dailyBalanceInGold: 0,
    cardNumber: "",
  });
  const [isSubmittingEdit, setIsSubmittingEdit] = useState(false);
  const [editError, setEditError] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    if (viewMode === "view") {
      fetchUsers();
    }
  }, [viewMode]);

  const getErrorMessage = (err, fallback) => {
    const status = err?.response?.status;
    if (status === 401) return "عدم دسترسی، لطفاً مجدداً وارد شوید";
    if (status === 403) return "شما مجوز انجام این عملیات را ندارید";
    return err?.response?.data?.message || fallback;
  };

  const fetchUsers = async () => {
    try {
      setError("");
      setIsLoadingUsers(true);
      const response = await axios.get("/Users");
      setUsers(response.data.data || []);
    } catch (error) {
      console.error(error);
      setError(getErrorMessage(error, "خطا در دریافت اطلاعات کاربران"));
    } finally {
      setIsLoadingUsers(false);
    }
  };

  const handleCreateUser = async (e) => {
    e.preventDefault();

    const userData = {
      ...newUser,
      email: "ssss@gmail.com",
    };

    try {
      setError("");
      setIsSubmitting(true);

      await axios.post("/Users", userData);

      setNewUser({
        userName: "",
        password: "",
        fullName: "",
        dailyBalanceInGold: 0,
        email: "",
      });

      setViewMode("view");
    } catch (error) {
      console.error(error);
      setError(getErrorMessage(error, "خطا در ثبت کاربر جدید"));
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleToggleStatus = async (user) => {
    try {
      setError("");
      setTogglingId(user.id);

      // PUT /Users/{id} expects the full UpdateRequest object (not a partial
      // patch), so we resend the user's existing fields with isActive flipped
      // to avoid wiping out fullName/address/phone/etc. on the backend.
      const payload = {
        fullName: user.fullName,
        age: user.age,
        gender: user.gender,
        isActive: !user.isActive,
        address: user.address,
        phone: user.phone,
        nationalCode: user.nationalCode,
        dailyBalanceInGold: user.dailyBalanceInGold,
        cardNumber: user.cardNumber,
      };

      await axios.put(`/Users/${user.id}`, payload);

      setUsers((prevUsers) =>
        prevUsers.map((u) =>
          u.id === user.id ? { ...u, isActive: !u.isActive } : u
        )
      );
    } catch (error) {
      console.error(error);
      setError(getErrorMessage(error, "خطا در تغییر وضعیت کاربر"));
    } finally {
      setTogglingId(null);
    }
  };

  const handleStartEdit = (user) => {
    setEditingUser(user);
    setEditForm({
      fullName: user.fullName || "",
      age: user.age ?? "",
      gender: user.gender || "Male",
      isActive: !!user.isActive,
      address: user.address || "",
      phone: user.phone || "",
      nationalCode: user.nationalCode || "",
      dailyBalanceInGold: user.dailyBalanceInGold ?? 0,
      cardNumber: user.cardNumber || "",
    });
    setError("");
    setEditError("");
    setViewMode("edit");
  };

  const handleCancelEdit = () => {
    setEditingUser(null);
    setEditError("");
    setViewMode("view");
  };

  const handleUpdateUser = async (e) => {
    e.preventDefault();
    if (!editingUser) return;

    try {
      setEditError("");
      setIsSubmittingEdit(true);

      // PUT /Users/{id} — MyApi.Models.User.UpdateRequest
      const payload = {
        fullName: editForm.fullName,
        age: editForm.age === "" ? null : Number(editForm.age),
        gender: editForm.gender,
        isActive: editForm.isActive,
        address: editForm.address,
        phone: editForm.phone,
        nationalCode: editForm.nationalCode,
        dailyBalanceInGold: Number(editForm.dailyBalanceInGold),
        cardNumber: editForm.cardNumber,
      };

      await axios.put(`/Users/${editingUser.id}`, payload);

      setUsers((prevUsers) =>
        prevUsers.map((u) =>
          u.id === editingUser.id ? { ...u, ...payload } : u
        )
      );

      setEditingUser(null);
      setViewMode("view");
    } catch (error) {
      console.error(error);
      setEditError(getErrorMessage(error, "خطا در ویرایش کاربر"));
    } finally {
      setIsSubmittingEdit(false);
    }
  };

  const filteredUsers = users.filter((user) => {
    const search = searchTerm.toLowerCase().trim();

    if (!search) return true;

    return (
      user.id?.toString().includes(search) ||
      user.fullName?.toLowerCase().includes(search) ||
      user.phoneNumber?.toLowerCase().includes(search) ||
      user.userName?.toLowerCase().includes(search) ||
      user.nationalCode?.toLowerCase().includes(search)
    );
  });

  return (
    <div className="gu-root" dir="rtl">
      <div className="gu-wrap">
        <button className="gu-back" onClick={() => navigate("/dashboard")}>
          → بازگشت به داشبورد
        </button>

        <div className="gu-header">
          <div className="gu-eyebrow">مدیریت کاربران</div>
          <h2 className="gu-title">فهرست و ثبت کاربران سامانه</h2>
        </div>

        {viewMode !== "edit" && (
          <div className="gu-tabs" role="tablist">
            <div className="gu-tab">
              <input
                type="radio"
                id="gu-tab-view"
                name="gu-viewmode"
                value="view"
                checked={viewMode === "view"}
                onChange={() => setViewMode("view")}
              />
              <label htmlFor="gu-tab-view">مشاهده کاربران</label>
            </div>
            <div className="gu-tab">
              <input
                type="radio"
                id="gu-tab-create"
                name="gu-viewmode"
                value="create"
                checked={viewMode === "create"}
                onChange={() => setViewMode("create")}
              />
              <label htmlFor="gu-tab-create">ثبت کاربر جدید</label>
            </div>
          </div>
        )}

        {viewMode === "view" && (
          <div className="gu-panel">
            {error && <p className="gu-error">{error}</p>}

            <div className="gu-search">
              <input
                type="text"
                placeholder="جستجو بر اساس ID، نام، تلفن یا کد ملی"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                disabled={isLoadingUsers}
              />
            </div>

            <div className="gu-table-card">
              <table>
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>نام کامل</th>
                    <th>تلفن</th>
                    <th>کد ملی</th>
                    <th>موجودی روزانه (طلا)</th>
                    <th>وضعیت</th>
                    <th>عملیات</th>
                  </tr>
                </thead>

                <tbody>
                  {isLoadingUsers ? (
                    <tr>
                      <td colSpan="7" className="gu-empty">
                        در حال بارگذاری...
                      </td>
                    </tr>
                  ) : filteredUsers.length > 0 ? (
                    filteredUsers.map((user) => (
                      <tr key={user.id}>
                        <td>{user.id}</td>
                        <td>{user.fullName || "-"}</td>
                        <td>{user.phoneNumber || user.phone || user.userName || "ندارد"}</td>
                        <td>{user.nationalCode || "ندارد"}</td>
                        <td>{user.dailyBalanceInGold}</td>
                        <td>
                          <button
                            type="button"
                            className={`gu-status gu-status-btn ${
                              user.isActive ? "is-active" : "is-inactive"
                            }`}
                            onClick={() => handleToggleStatus(user)}
                            disabled={togglingId === user.id}
                          >
                            {togglingId === user.id
                              ? "..."
                              : user.isActive
                              ? "فعال"
                              : "غیرفعال"}
                          </button>
                        </td>
                        <td>
                          <button
                            type="button"
                            className="gu-status gu-status-btn"
                            onClick={() => handleStartEdit(user)}
                          >
                            ویرایش
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7" className="gu-empty">
                        کاربری یافت نشد
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {viewMode === "create" && (
          <div className="gu-panel">
            <div className="gu-form-card">
              <form onSubmit={handleCreateUser}>

                <div className="gu-field">
                  <label>نام کاربری</label>
                  <input
                    type="text"
                    placeholder="مثال: 09123456789"
                    value={newUser.userName}
                    onChange={(e) =>
                      setNewUser({ ...newUser, userName: e.target.value })
                    }
                    required
                  />
                </div>

                <div className="gu-field">
                  <label>کلمه عبور</label>

                  <div className="gu-password-box">
                    <input
                      type={showPassword ? "text" : "password"}
                      placeholder="مثال: MyPassword123"
                      value={newUser.password}
                      onChange={(e) =>
                        setNewUser({ ...newUser, password: e.target.value })
                      }
                      required
                    />

                    <button
                      type="button"
                      className="gu-password-toggle"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {showPassword ? "🙈" : "👁"}
                    </button>
                  </div>
                </div>

                <div className="gu-field">
                  <label>نام کامل</label>
                  <input
                    type="text"
                    placeholder="مثال: علی محمدی"
                    value={newUser.fullName}
                    onChange={(e) =>
                      setNewUser({ ...newUser, fullName: e.target.value })
                    }
                    required
                  />
                </div>

                <div className="gu-field">
                  <label>موجودی روزانه (طلا)</label>
                  <input
                    type="number"
                    placeholder="مثال: 100"
                    value={newUser.dailyBalanceInGold}
                    onChange={(e) =>
                      setNewUser({
                        ...newUser,
                        dailyBalanceInGold: Number(e.target.value),
                      })
                    }
                    required
                  />
                </div>

                <div className="gu-field">
                  <label>ایمیل</label>
                  <input
                    type="email"
                    placeholder="admin@satrex.ir"
                    value={newUser.email}
                    disabled
                  />
                  <div className="gu-field-hint">
                    این مقدار به‌صورت خودکار ارسال می‌شود
                  </div>
                </div>

                <button type="submit" className="gu-submit" disabled={isSubmitting}>
                  {isSubmitting ? "در حال ثبت..." : "ثبت کاربر جدید"}
                </button>

              </form>

              {error && <p className="gu-error gu-form-error">{error}</p>}
            </div>
          </div>
        )}

        {viewMode === "edit" && editingUser && (
          <div className="gu-panel">
            <div className="gu-header">
              <div className="gu-eyebrow">ویرایش کاربر</div>
              <h2 className="gu-title">
                {editingUser.fullName || editingUser.userName || `کاربر #${editingUser.id}`}
              </h2>
            </div>

            <div className="gu-form-card">
              <form onSubmit={handleUpdateUser}>

                <div className="gu-field">
                  <label>نام کامل</label>
                  <input
                    type="text"
                    placeholder="مثال: علی محمدی"
                    value={editForm.fullName}
                    onChange={(e) =>
                      setEditForm({ ...editForm, fullName: e.target.value })
                    }
                    required
                  />
                </div>

                <div className="gu-field">
                  <label>سن</label>
                  <input
                    type="number"
                    placeholder="مثال: 30"
                    value={editForm.age}
                    onChange={(e) =>
                      setEditForm({ ...editForm, age: e.target.value })
                    }
                  />
                </div>

                <div className="gu-field">
                  <label>جنسیت</label>
                  <select
                    value={editForm.gender}
                    onChange={(e) =>
                      setEditForm({ ...editForm, gender: e.target.value })
                    }
                  >
                    <option value="Male">مرد</option>
                    <option value="Female">زن</option>
                  </select>
                </div>

                <div className="gu-field">
                  <label>آدرس</label>
                  <input
                    type="text"
                    placeholder="آدرس کاربر"
                    value={editForm.address}
                    onChange={(e) =>
                      setEditForm({ ...editForm, address: e.target.value })
                    }
                  />
                </div>

                <div className="gu-field">
                  <label>تلفن</label>
                  <input
                    type="text"
                    placeholder="مثال: 09123456789"
                    value={editForm.phone}
                    onChange={(e) =>
                      setEditForm({ ...editForm, phone: e.target.value })
                    }
                  />
                </div>

                <div className="gu-field">
                  <label>کد ملی</label>
                  <input
                    type="text"
                    placeholder="کد ملی کاربر"
                    value={editForm.nationalCode}
                    onChange={(e) =>
                      setEditForm({ ...editForm, nationalCode: e.target.value })
                    }
                  />
                </div>

                <div className="gu-field">
                  <label>موجودی روزانه (طلا)</label>
                  <input
                    type="number"
                    placeholder="مثال: 100"
                    value={editForm.dailyBalanceInGold}
                    onChange={(e) =>
                      setEditForm({
                        ...editForm,
                        dailyBalanceInGold: Number(e.target.value),
                      })
                    }
                    required
                  />
                </div>

                <div className="gu-field">
                  <label>شماره کارت</label>
                  <input
                    type="text"
                    placeholder="شماره کارت کاربر"
                    value={editForm.cardNumber}
                    onChange={(e) =>
                      setEditForm({ ...editForm, cardNumber: e.target.value })
                    }
                  />
                </div>

                <div className="gu-field">
                  <label>
                    <input
                      type="checkbox"
                      checked={editForm.isActive}
                      onChange={(e) =>
                        setEditForm({ ...editForm, isActive: e.target.checked })
                      }
                    />
                    {" "}کاربر فعال باشد
                  </label>
                </div>

                <button type="submit" className="gu-submit" disabled={isSubmittingEdit}>
                  {isSubmittingEdit ? "در حال ذخیره..." : "ذخیره تغییرات"}
                </button>

                <button
                  type="button"
                  className="gu-back"
                  onClick={handleCancelEdit}
                  disabled={isSubmittingEdit}
                >
                  انصراف
                </button>

              </form>

              {editError && <p className="gu-error gu-form-error">{editError}</p>}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Users;
